type ClassValue = string | number | null | undefined | false | Record<string, boolean | undefined>;

/**
 * Tiny class-name joiner (a `clsx` stand-in without the dependency).
 *
 * @example cn(styles.button, isActive && styles.active, { [styles.lg]: size === 'lg' })
 */
export function cn(...values: ClassValue[]): string {
  const classes: string[] = [];

  for (const value of values) {
    if (!value) continue;

    if (typeof value === 'string' || typeof value === 'number') {
      classes.push(String(value));
      continue;
    }

    for (const [key, enabled] of Object.entries(value)) {
      if (enabled) classes.push(key);
    }
  }

  return classes.join(' ');
}
